import { generateRandomId } from '@sxm-core/utility-code/typescript/browser-common-cryptography';

const cookieName = 'SF_ANON_ID';

export function getSalesforceAnonymousIdCookieValue() {
    const cookiePieces = decodeURIComponent(document.cookie)?.split(';') || [];
    const cookie = cookiePieces
        .find((piece) => piece.trim().startsWith(cookieName))
        ?.trim();
    return cookie?.split('=')?.[1];
}

export function setSalesforceAnonymousIdCookieValue(anonymousId: string) {
    const expirationDate = new Date(2147483647 * 1000).toUTCString();
    document.cookie = `${cookieName}=${anonymousId};sameSite=lax;path=/;domain=.siriusxm.com;expires=${expirationDate}`;
}

export function getAnonymousId(): string {
    const cookieValue = getSalesforceAnonymousIdCookieValue();
    if (cookieValue !== undefined) {
        return cookieValue;
    } else {
        const anonymousId = generateRandomId(16);
        setSalesforceAnonymousIdCookieValue(anonymousId);
        return anonymousId;
    }
}
